import React, { ReactNode, useEffect } from 'react';
import { useReloadAreena } from '../reload';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { rememberLastProfileLocalStorageKey } from '../../environment';
import { useAuthContext } from '../../contexts/AuthContext/AuthContext';

const RememberMeRedirect: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const reloadAreena = useReloadAreena();
  const { getItem: getIsRememberMeSet } = useLocalStorage<boolean>({
    key: rememberLastProfileLocalStorageKey,
  });
  const isRememberMeSet = getIsRememberMeSet();
  const { user } = useAuthContext();

  useEffect(() => {
    if (isRememberMeSet) {
      reloadAreena(user);
    }
  }, [isRememberMeSet, reloadAreena, user]);

  return isRememberMeSet ? null : children;
};

export default RememberMeRedirect;
